const data=[
    {
    id:1,
    ques:"HTML full form is:",
    a:"Hypertext Markup Language",
    b:"Hypertext Map Language",
    c:"Hello Mini Hanguage",
    d:"None of these",
    
},
{
    id:2,
    ques:"Syntax of breaking line",
    a:"<break>",
    b:"<br>",
    c:"<brk>",
    d:"None od these"
},
{
    id:3,
    ques:"How to change color",
    a:"color(blue)",
    b:"color:blue",
    c:"color:blue;",
    d:"color=>blue"
},
{
    id:4,
    ques:"How to add padding",
    a:"padding:12",
    b:"padding:12px;",
    c:"padding->12",
    d:"padding(10)"
},
]
export default data;